import { axiosPost } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';

export const readSettingList = async () => {
  const payload = {
    path: '/point-settings/list',
  };

  return sendRequest(payload, 'readSettingList', axiosPost);
};

export const readSettingDetail = async (settingId: string) => {
  const payload = {
    path: '/point-settings/detail',
    body: {
      settingId,
    },
  };
  return sendRequest(payload, 'readSettingDetail', axiosPost);
};

export const readSettingAcumulatedList = async (settingId: string) => {
  const payload = {
    path: '/point-settings/accumulated-list',
    body: {
      settingId,
    },
  };
  return sendRequest(payload, 'readSettingAcumulated', axiosPost);
};

export const readPointUserList = async () => {
  const payload = {
    path: '/point-admins/user-tot-list',
    body: {},
  };
  return sendRequest(payload, 'readPointUserList', axiosPost);
};

export const readPointUserLedgerList = async () => {
  const payload = {
    path: '/point-admins/user-ledger-list',
    body: {},
  };
  return sendRequest(payload, 'readPointUserLedgerList', axiosPost);
};

export const readPointUserLedgerTotal = async (pointId: string) => {
  const payload = {
    path: '/point-admins/user-ledger-total',
    body: { pointId },
  };
  return sendRequest(payload, 'readPointUserDetail', axiosPost);
};

export const readPointUserDetailList = async (pointId: string) => {
  const payload = {
    path: '/point-admins/user-detail',
    body: { pointId },
  };
  return sendRequest(payload, 'readPointUserDetail', axiosPost);
};

export const readPointUserDetailInfo = async (pointId: string) => {
  const payload = {
    path: '/point-admins/user-detail-info',
    body: { pointId },
  };
  return sendRequest(payload, 'readPointUserDetailInfo', axiosPost);
};

export const readPointStakeSettingList = async (settingId: string) => {
  const payload = {
    path: '/point-settings/season-list',
    body: { settingId },
  };
  return sendRequest(payload, 'readPointStakeSettingList', axiosPost);
};

export const readPointAchieveList = async (settingId: string) => {
  const payload = {
    path: '/point-settings/achieve-list',
    body: { settingId },
  };
  return sendRequest(payload, 'readPointAchieveList', axiosPost);
};

export const readPointSeasonList = async (settingId: string) => {
  const payload = {
    path: '/point-settings/season-list',
    body: { settingId },
  };
  return sendRequest(payload, 'readPointSeasonList', axiosPost);
};
